// extracted by mini-css-extract-plugin
export var deliveryRow = "_nt-a";
export var fixedHeight = "_nt-4";
export var freightLogo = "_nt-9";
export var fullWidth = "_nt-3";
export var priceColumn = "_nt-5";
export var radioSelected = "_nt-7";
export var radioUnselected = "_nt-6";
export var selectedOption = "_nt-2";
export var selectedOptionContainer = "_nt-1";
export var selection = "_nt-0";
export var tallSkeletonText = "_nt-8";